import presentation from "../../content/registry/presentation.json";

export type InsightCard = {
  title: string;
  description: string;
};

export const keyInsightCards: InsightCard[] = presentation.keyInsightCards;
